<div id="main-container" class="col-md-4 gradientBg">
  <h1>{{ mainTitle }}</h1>
</div>

@for (text of texts; track text) {
  <div id="questionLists" class="col-md-10 mt-5">
    <h2>{{ text.title }}</h2>
    <p>
      {{ text.text }}
    </p>
    <p>
      {{ text.text2 }}
    </p>
    <p>
      {{ text.text3 }}
    </p>
  </div>
}
